<template>
  <Head>
      <Meta property="og:url" :content="'https://aiboosted.biz' + $route.path"/>
      <Meta name="twitter:card" content="summary_large_image"/>
      <Meta property="og:image" content="https://aiboosted.biz/img/OgImage.png"/>
      <Meta property="og:type" content="website"/>
      <Meta name="twitter:image" content="https://aiboosted.biz/img/OgImage.png"/>
  </Head>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
